function Calendar() {
  return (
    <svg viewBox="0 0 48 48" aria-hidden="true">
      <rect x="9" y="10" width="30" height="31" rx="2" />
      <path d="M9 18h30" />
      <path d="M16 6v8M32 6v8" />
      <path d="M16 24h2M23 24h2M30 24h2M16 31h2M23 31h2M30 31h2" />
    </svg>
  );
}

export default Calendar;
